module.exports = __webpack_public_path__ + "assets/img/Group_264@2x.245c7bc0.png";